<template>
	<div class="order-detail order-pay" v-show="loaded">
		<div class="pay-detail bg-white pay-split">
			<div class="space"></div>
			<div class="row">
				<div class="pull-left">应付金额</div>
				<div class="pull-right" :class="{yellow: !is_split}">
					￥<span v-text="order.to_pay_amount"></span>
				</div>
			</div>
			<div class="row pay-split-row top-solid-line" v-if="is_split">
				<div class="pull-left">已付金额</div>
				<div class="pull-right">
					￥<span v-text="order.paid_price"></span>
				</div>
			</div>
			<div class="row pay-split-row" v-if="is_split">
				<div class="pull-left">支付金额</div>
				<div class="yellow pull-right">
					<span class="bg-grey" style="padding: 5px 10px;">
						<span @click="decrAmount" style="width: 20px;padding:5px 10px;">
							<img src="/static/img/ic_minus.png" style="width:12px"/>
						</span>
						<input type="tel" v-model.number="to_pay_amount" @blur="onAmountChanged" class="split-amount" />
						<span @click="incrAmount" style="width: 20px;padding:5px 10px;">
							<img src="/static/img/ic_plus.png" style="width:12px"/>
						</span>
					</span>
				</div>
			</div>
			<div class="row pay-split-row" v-if="is_split">
				<div class="pull-left">剩余待付金额</div>
				<div class="yellow pull-right">
					￥<span v-text="to_pay_total"></span>
				</div>
			</div>
			<div class="row bg-grey" v-if="is_split">
				<div style="font-size:12px;">
					<img src="/static/img/warning.jpg" class="warning">
					如支付金额超过限额，请在上方调小金额后支付
				</div>
			</div>
			<div class="space" v-if="!is_split"></div>
			<div class="row border-line">
				<div class="pull-left">选择支付方式</div>
			</div>
			<div class="row ml-50 mr-20" :class="{'border-line': index < onlines.length - 1}" v-for="(item, index) in onlines" :key="item.routeCode" @click="onChecked(index)" v-show="!is_split || (is_split && item.iconName !== 'alipay')">
				<div class="pull-left">
					<div :class="'ic_' + item.iconName"></div>
				</div>
				<div class="pull-left">
					<p style="margin-top:3px; margin-left:5px;margin-bottom:0;">{{ item.title }}</p>
				</div>
				<div class="pull-right"><img class="pay-way" :src="item.checkImage"></div>
			</div>
		</div>
		<div class="actions" v-show="showAction">
			<mt-button type="primary" :disabled="disabled" @click="onSubmitClick">去支付</mt-button>
		</div>
		<div id="payForm2" class="hidden"></div>
		<div class="row" style="height:50px; border-bottom: 1px dashed #ccc;">
		</div>
		<div class="row">
			<div style="text-align:center;color: #64a0e5;padding-top:10px;" @click="onQaClick">
				<a href="javascript:void(0);">支付时出现限额错误?</a>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Button } from 'mint-ui'
import wx from 'weixin-js-sdk'

export default {
	name: 'PayOnline',
	data: function () {
		return {
			'loaded': false,
			'payWay': -1,
			'selectedPay': {},
			'disabled': true,
			'showAction': true,
			'pay_amount': 0,
			'to_pay_amount': 0,
			'timer': null,
			'counting': 0,
			'payTraceNo': null,
			'to_pay_total': 0,
			'is_split': false
		}
	},
	computed: {
		...mapGetters({
			order: 'getOrder',
			channels: 'getPayChannels',
			qyh: 'getQyh'
		}),
		onlines () {
			return this.channels
		},
		step () {
			return this.qyh.pay_split_step || 3000
		}
	},
	created () {
		this.loadPayChannels()
		console.log('pay path: ', this.$route)
	},
	components: {
		'mt-button': Button
	},
	mounted: function () {
		this.is_split = this.$route.name === 'PaySplit'
		this.setForSplit()
		this.fetchDetail()
	},
	methods: {
		onQaClick () {
			if (this.is_split) {
				this.toast('请调小金额后尝试')
			} else {
				this.toast('请尝试拆单支付')
				this.is_split = true
				this.setForSplit()
				this.setToPayAmount()
				this.refreshRemain()
			}
		},
		setForSplit () {
			if (this.is_split) {
				this.setPageTitle('拆单支付')
			} else {
				this.setPageTitle('整单支付')
			}
		},
		onAmountChanged () {
			if (isNaN(this.to_pay_amount)) {
				this.to_pay_amount = 0
			}
			this.to_pay_amount = parseFloat(this.to_pay_amount)
			if (isNaN(this.to_pay_amount)) {
				this.to_pay_amount = 0
			} else if (this.to_pay_amount.toString().split('.').length > 1) {
				this.to_pay_amount = this.to_pay_amount.toFixed(2)
			}

			let total = this.order.to_pay_amount - this.order.paid_price
			if (this.to_pay_amount > total) {
				this.to_pay_amount = total
				try {
					this.to_pay_amount = this.to_pay_amount.toFixed(2)
				} catch (e) {
					//
				}
			}
			this.pay_amount = this.to_pay_amount
			this.refreshRemain()
			console.log('to pay: ', this.pay_amount, this.to_pay_amount)
		},
		onChecked (index) {
			this.payWay = index
			this.selectedPay = this.onlines[index]
			this.$store.dispatch('setPayChannelSelected', {'item': this.selectedPay})
			this.disabled = false
			this.$ls.set('selectedPay', this.selectedPay)
			this.showAction = true
			console.log('selectedPay: ', this.selectedPay)
		},
		setToPayAmount () {
			if (!this.is_split) {
				this.to_pay_amount = this.to_pay_total
				this.pay_amount = this.to_pay_total
			} else {
				if (this.step > this.to_pay_total) {
					this.to_pay_amount = this.to_pay_total
				} else {
					this.to_pay_amount = this.step
				}
				this.pay_amount = this.to_pay_amount
			}
			console.log(this.to_pay_amount)
		},
		flSub(arg1, arg2) {
			//
			if (isNaN(arg1)) { arg1 = 0 }
			if (isNaN(arg2)) { arg2 = 0 }
			arg1 = Number(arg1)
			arg2 = Number(arg2)
			let r1, r2, m, n;
			try {
				r1 = arg1.toString().split(".")[1].length
			} catch (e) {
				r1 = 0
			}

			try {
				r2 = arg2.toString().split(".")[1].length
			} catch (e) {
				r2 = 0
			}

			m = Math.pow(10, Math.max(r1, r2))
			n = (r1 >= r2) ? r1 : r2
			return ((arg1 * m - arg2 * m) / m).toFixed(n)
		},
		refreshRemain () {
			let toPayAmount = Number(this.order.to_pay_amount)
			let paidPrice = Number(this.order.paid_price)
			let payAmount = Number(this.pay_amount)

			if (toPayAmount.toString().split(".").length > 1) { this.order.to_pay_amount = toPayAmount.toFixed(2) }
			if (paidPrice.toString().split(".").length > 1) { this.order.paid_price = paidPrice.toFixed(2) }
			if (payAmount.toString().split(".").length > 1) { this.pay_amount = payAmount.toFixed(2) }
			console.log('DEBUG-refresh Remain , toPayTotal...' + this.to_pay_total.toString() + ' paidPrice' + this.order.paid_price.toString() + '  payAmount ' + this.pay_amount.toString())
			let p1 = this.flSub(this.order.to_pay_amount, this.order.paid_price)
			this.to_pay_total = this.flSub(p1, this.pay_amount)
		},
		incrAmount () {
			console.log(this.to_pay_amount)
			let total = this.flSub(this.order.to_pay_amount, this.order.paid_price)
			if (this.to_pay_amount + this.step >= total) {
				this.to_pay_amount = total
			} else {
				this.to_pay_amount = this.to_pay_amount + this.step
			}
			this.pay_amount = this.to_pay_amount
			this.refreshRemain()
			console.log(this.to_pay_amount)
		},
		decrAmount () {
			console.log(this.to_pay_amount)
			if (this.to_pay_amount - this.step <= 0) {
			} else {
				this.to_pay_amount = this.to_pay_amount - this.step
			}
			this.pay_amount = this.to_pay_amount
			this.refreshRemain()
			console.log(this.to_pay_amount)
		},
		rollingPayStatus () {
			if (this.timer) {
				clearTimeout(this.timer)
				this.timer = null
			}
			if (this.counting >= 300) {
				// 5分钟
				this.toast('支付超时')
				window.location.reload()
			} else {
				let self = this
				this.timer = setTimeout(function () {
					self.checkPayStatus(true)
				}, 2000)
				this.counting += 2
			}
		},
		checkPayStatus (rolling) {
			let url = '/api/payments/status/' + this.payTraceNo
			this.$http.get(url).then(response => {
				// console.log(response)
				var rs = response.body
				if (rs.code === 0) {
					if (rs.data.status === 1) {
						this.$store.dispatch('setOrder', {'order': rs.data.order})
						this.refreshRemain()
						this.setToPayAmount()
						this.refreshRemain()
						console.log('DEBUG-订单支付成功,' + this.pay_amount.toString())
						if (rs.data.full_pay === true) {
							window.location.href = '#/orders/verify/' + this.$route.params.id
						}
					} else if (rs.data.status === 2) {
						this.toast('支付失败，请重新支付')
					} else {
						if (rolling) {
							this.rollingPayStatus()
						} else {
							this.toast('支付超时')
							window.location.reload()
						}
					}
				} else {
					this.handleHttpError(response)
				}
			}, response => {
				console.log(response)
				this.handleHttpError(response)
			})
		},
		loadPayChannels () {
			if (this.channels.length > 0) {
				this.loadingHide()
				this.$store.dispatch('setPayChannelSelected', {'item': null})
				this.loaded = true
				return
			}
			this.fetchPayChannels(rs => {
				this.loaded = true
			})
		},
		fetchDetail () {
			if (this.order && this.order.to_pay_amount) {
				this.refreshRemain()
				this.setToPayAmount()
				this.refreshRemain()
				console.log('DEBUG-存在订单信息刷新,' + this.pay_amount.toString())
				this.loaded = true
				return
			}
			this.loading('正在读取订单信息...')
			this.getOrderSimpleDetail(this.$route.params.id, order => {
				this.refreshRemain()
				this.setToPayAmount()
				this.refreshRemain()
				this.loaded = true
			})
		},
		configWxPay (data) {
			if (!data) {
				return
			}
			if (data.transStatus === 3) {
				this.toast(data.errorMsg)
				return
			}
			wx.config({
				debug: false,
				appId: data.jsapi.appId,
				timestamp: data.jsapi.timestamp,
				nonceStr: data.jsapi.nonceStr,
				signature: data.jsapi.signature,
				jsApiList: ['checkJsApi', 'chooseWXPay']
			})
			let self = this
			this.payTraceNo = data.traceNo
			wx.ready(function () {
				wx.checkJsApi({
					jsApiList: ['chooseWXPay'] // 需要检测的JS接口列表，所有JS接口列表见附录2,
				})
				wx.chooseWXPay({
					timestamp: data.timestamp,
					nonceStr: data.nonceStr,
					package: data.packageName,
					signType: data.signType,
					paySign: data.sign,
					success: function (res) {
					},
					cancel: function (res) {
						console.log(res)
					}
				})
				self.rollingPayStatus()
			})
			wx.error(function (res) {
				console.log(res)
				self.toast(res)
			})
		},
		toMpLogin () {
			let url = '/api/mp?order_no=' + this.$route.params.id
			window.location.href = url
		},
		onSubmitClick () {
			if (!this.pay_amount || this.pay_amount === 0) {
				this.toast('请填写支付金额,' + this.pay_amount.toString())
				return
			}
			let total = this.flSub(this.order.to_pay_amount, this.order.paid_price)
			if (this.is_split && this.pay_amount > total) {
				this.toast('请重新输入支付金额，已超过待支付金额')
				return
			}
			let url = '/api/orders/payments/online/' + this.order.order_no
			let params = {
				amount: this.pay_amount,
				route_code: this.selectedPay.routeCode,
				route_name: this.selectedPay.name,
				vendor_title: this.selectedPay.title,
				split: this.is_split ? 1 : 0
			}
			// this.toast(window.location.href)
			this.loading('正在提交...')
			this.$http.post(url, params).then(response => {
				console.log(response)
				var rs = response.body
				if (rs.code === 0) {
					if (this.selectedPay.name === 'weixin-h5') {
						this.loadingHide()
						if (rs.data.code === 'to_mp_login') {
							this.toMpLogin()
						} else {
							this.configWxPay(rs.data)
						}
					} else if (this.selectedPay.name === 'weixin-qr') {
						this.loadingHide()
						// 展示二维码
						let mweb = {'weixin': true, 'alipay': false}
						Object.assign(mweb, rs.data)
						this.$store.dispatch('setMweb', {'mweb': mweb})
						let it = null
						let self = this
						it = setTimeout(function () {
							self.$router.push({name: 'PayQr', params: {'name': 'weixin', 'id': self.order.order_no}})
							clearTimeout(it)
						}, 200)
					} else if (this.selectedPay.name === 'alipay-h5') {
						this.loadingHide()
						window.location.href = rs.data.payUrl
					} else if (this.selectedPay.name === 'alipay-qr') {
						this.loadingHide()
						// 展示二维码
						let mweb = {'alipay': true, 'weixin': false}
						Object.assign(mweb, rs.data)
						this.$store.dispatch('setMweb', {'mweb': mweb})
						let it = null
						let self = this
						it = setTimeout(function () {
							self.$router.push({name: 'PayQr', params: {'name': 'alipay', 'id': self.order.order_no}})
							clearTimeout(it)
						}, 200)
					} else if (this.selectedPay.name.startsWith('allinpay') === true) {
						this.loadingHide()
						window.location.href = rs.data.payUrl
					} else if (this.selectedPay.name === 'bank-h5') {
						document.body.innerHTML = rs.data.payBody
						document.getElementById("auto_click").click();
					}
					console.log(this.selectedPay.name)
				} else {
					this.loadingHide()
					this.handleHttpError(response)
				}
			}, response => {
				console.log(response)
				this.handleHttpError(response)
			})
		}
	}
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// PayOnline.vue?8257ccd2